module.exports = __webpack_public_path__ + "21f0db397e1056eeac203e1f68d7eddb.MP3";